module.exports = __webpack_public_path__ + "static/img/homeImgJt.988b095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/homeImgJt.png
// module id = 2k8l
// module chunks = 1